import { render, staticRenderFns } from "./HtSubmenu.vue?vue&type=template&id=920d5256&scoped=true"
import script from "./HtSubmenu.vue?vue&type=script&lang=js"
export * from "./HtSubmenu.vue?vue&type=script&lang=js"
import style0 from "./HtSubmenu.vue?vue&type=style&index=0&id=920d5256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920d5256",
  null
  
)

export default component.exports